export const isValidTextLenght = (TextLength, MaxLength) => {
  return !MaxLength || TextLength <= MaxLength;
};
